define('TescoMobile_DataLayer/js/view/subscription-details-mixin',['mage/utils/wrapper', 'jquery'], function (wrapper, $) {
  'use strict';

  return function (subscriptionDetails) {
    subscriptionDetails.navigate = wrapper.wrapSuper(subscriptionDetails.navigate, function (step) {
      if ($.data(document.body, 'dl-last-event') !== 'dl-checkout-step-' + step.code) {
        $('body').trigger('dl-checkout-step-' + step.code);
        $.data(document.body, 'dl-last-event', 'dl-checkout-step-' + step.code);
      }
      return this._super(step);
    });
    return subscriptionDetails;
  };
});

